import React, { useEffect } from "react";
import { useLocation } from "react-router-dom"; // Correct way in React Router v6
import {
  Services,
  Portfolios,
  Advantages,
  Testimonials,
} from "json/landingPageData1";
import Header1 from "parts/Header1";
import Hero1 from "parts/Hero1";
import Service1 from "parts/Service1";
import Portfolio1 from "parts/Portfolio1";
import Advantage1 from "parts/Advantage1";
import Testimonial1 from "parts/Testimonial1";
import Discuss1 from "parts/Discuss1";
import Footer1 from "parts/Footer1";

const LandingPage1 = () => {
  const location = useLocation(); // Get current URL

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top on page load

    // Scroll to section if there's a hash (e.g., #part2)
    if (location.hash) {
      setTimeout(() => {
        const section = document.querySelector(location.hash);
        if (section) {
          section.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    }
  }, [location]); // Runs when location changes

  return (
    <>
      <Header1 />
      <Hero1 />
      <Service1 data={Services} />
      <Portfolio1 data={Portfolios} />
      <Advantage1 data={Advantages} />
      <Testimonial1 data={Testimonials} />
      <Discuss1 />
      <Footer1 />
    </>
  );
};

export default LandingPage1;
